var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css.index},[_c('PageHeaderAdfox'),_vm._v(" "),_c('Grid',{attrs:{"articles":_vm.articles,"presets":_vm.presets}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }